(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-quantity-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /**
   * Haptic Feedback Utility
   * - Respects device silent mode (Android handles this automatically)
   * - iOS doesn't support Vibration API, so we skip it
   * - Uses light 12ms vibration for tactile feedback
   */
  var HapticFeedback = {
    _canVibrate: null,
    _isEnabled: true,

    init: function() {
      // Check vibration support once
      this._canVibrate = 'vibrate' in navigator;

      // Check for reduced motion preference
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this._isEnabled = false;
      }
    },

    light: function() {
      if (!this._isEnabled || !this._canVibrate) return;
      try {
        navigator.vibrate(12);
      } catch (e) {}
    },

    medium: function() {
      if (!this._isEnabled || !this._canVibrate) return;
      try {
        navigator.vibrate(18);
      } catch (e) {}
    }
  };

  HapticFeedback.init();

  function initBundlePickers(root) {
    if (!root || !root.querySelectorAll) return;

    var pickers = root.querySelectorAll('[data-bundle-picker]:not([data-bundle-picker-initialized])');
    if (!pickers.length) return;

    pickers.forEach(function (picker) {
      picker.setAttribute('data-bundle-picker-initialized', 'true');

      var radioInputs = Array.from(picker.querySelectorAll('input[type="radio"][data-bundle-qty]'));
      if (!radioInputs.length) return;

      // Find the matching product form for this section
      var sectionId = picker.getAttribute('data-section-id');
      var form = null;

      if (sectionId) {
        form = document.querySelector('product-form-component[data-section-id="' + sectionId + '"]');
      }
      if (!form) {
        form = document.querySelector('product-form-component');
      }
      if (!form) return;

      // Quantity input inside quantity-selector-component
      var quantityInput = form.querySelector('quantity-selector-component input[name="quantity"]');
      if (!quantityInput) return;

      radioInputs.forEach(function (input) {
        var label = input.closest('.bundle-picker__button');

        // Touch feedback on press
        if (label) {
          label.addEventListener('touchstart', function() {
            HapticFeedback.light();
          }, { passive: true });
        }

        input.addEventListener('change', function () {
          if (!input.checked) return;

          var qty = parseInt(input.getAttribute('data-bundle-qty') || '1', 10);
          if (!qty || qty < 1) qty = 1;

          // Haptic feedback on selection
          HapticFeedback.medium();

          quantityInput.value = qty;

          // Let the theme JS know quantity changed
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

          // Track bundle selection
          var labelEl = label ? label.querySelector('.bundle-picker__main') : null;
          var labelText = labelEl ? labelEl.textContent.trim() : '';

          // Store bundle label on quantity input so product-form.js can read it
          quantityInput.dataset.bundleLabel = (qty > 1 && labelText) ? labelText : '';

          // Update ATC button text immediately to reflect bundle selection
          var atcTextEl = document.querySelector('[ref="addToCartButton"] .add-to-cart-text__content');
          if (atcTextEl && !atcTextEl.textContent.includes('Select')) {
            if (!atcTextEl.dataset.baseText) {
              atcTextEl.dataset.baseText = atcTextEl.textContent.trim();
            }
            var baseText = atcTextEl.dataset.baseText || (window.Theme && Theme.translations && Theme.translations.add_to_cart) || 'Add to Cart';
            atcTextEl.textContent = (qty > 1 && labelText) ? baseText + ' ' + labelText : baseText;
          }

          if (window.NetherAnalytics) {
            NetherAnalytics.track('select_bundle', {
              bundle_quantity: qty,
              bundle_label: labelText,
              page_path: window.location.pathname
            });
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundlePickers(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBundlePickers(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form-submit-button"] && !Shopify.designMode) return;
  try {
    // Add loading state on form submit
  document.querySelectorAll('.contact-form__form').forEach(form => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('.submit-button');
      if (btn) btn.classList.add('is-loading');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["feature-spotlight-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  function initFeatureSpotlight() {
    const galleries = document.querySelectorAll('[data-feature-spotlight]');

    galleries.forEach(function(gallery) {
      const track = gallery.querySelector('[data-spotlight-track]');
      const cards = gallery.querySelectorAll('[data-spotlight-card]');

      if (!track || !cards.length) return;

      // Intersection Observer for card animations
      const cardObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          const content = entry.target.querySelector('[data-spotlight-content]');

          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            if (content) {
              // Slight delay for staggered effect
              setTimeout(function() {
                content.classList.add('is-visible');
              }, 100);
            }
          } else {
            // Optional: remove animation when out of view for re-trigger
            // entry.target.classList.remove('is-in-view');
            // if (content) content.classList.remove('is-visible');
          }
        });
      }, {
        root: track,
        threshold: 0.5,
        rootMargin: '0px'
      });

      cards.forEach(function(card) {
        cardObserver.observe(card);
      });

      // Scroll position tracking for fade indicators
      function updateScrollIndicators() {
        const scrollLeft = track.scrollLeft;
        const maxScroll = track.scrollWidth - track.clientWidth;

        gallery.dataset.canScrollLeft = scrollLeft > 10 ? 'true' : 'false';
        gallery.dataset.canScrollRight = scrollLeft < maxScroll - 10 ? 'true' : 'false';
      }

      track.addEventListener('scroll', updateScrollIndicators, { passive: true });
      updateScrollIndicators();

      // Handle resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateScrollIndicators, 100);
      }, { passive: true });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeatureSpotlight);
  } else {
    initFeatureSpotlight();
  }

  // Reinitialize on Shopify section events
  document.addEventListener('shopify:section:load', initFeatureSpotlight);
  document.addEventListener('shopify:block:select', initFeatureSpotlight);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-proof-viewers"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  function initSocialProofViewers() {
    var containers = document.querySelectorAll('[data-social-proof-viewers]');

    containers.forEach(function(container) {
      var countEl = container.querySelector('[data-viewer-count]');
      if (!countEl) return;

      var min = parseInt(container.dataset.min, 10) || 3;
      var max = parseInt(container.dataset.max, 10) || 15;
      var currentCount = parseInt(countEl.textContent, 10) || min;

      // Occasionally update the count to simulate real-time viewers
      function updateCount() {
        // Small random change: -1, 0, or +1
        var change = Math.floor(Math.random() * 3) - 1;
        currentCount = Math.max(min, Math.min(max, currentCount + change));
        countEl.textContent = currentCount;
      }

      // Update every 8-15 seconds
      var interval = (Math.random() * 7000) + 8000;
      setInterval(updateCount, interval);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialProofViewers);
  } else {
    initSocialProofViewers();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["star-rating-pill"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  function initStarRatingPill() {
    var pills = document.querySelectorAll('[data-star-rating-pill]');

    pills.forEach(function(pill) {
      // Skip if already has SSR data
      if (pill.classList.contains('star-rating-pill--loaded')) {
        setupScrollBehavior(pill);
        return;
      }

      var productId = pill.dataset.productId;
      if (!productId) return;

      // Try to get rating from Judge.me DOM
      fetchJudgeMeRating(productId, function(data) {
        if (data && data.count > 0) {
          renderStars(pill, data.rating, data.count);
          pill.dataset.hasReviews = 'true';
          pill.classList.add('star-rating-pill--loaded');
        } else {
          pill.dataset.hasReviews = 'false';
        }
      });

      setupScrollBehavior(pill);
    });
  }

  function setupScrollBehavior(pill) {
    var link = pill.querySelector('.star-rating-pill__link');

    if (link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();

        // Try to find Judge.me widget first, then fall back to other selectors
        var target = document.querySelector('.jdgm-rev-widg') ||
                     document.querySelector('.jdgm-widget') ||
                     document.querySelector('[class*="jdgm-rev"]') ||
                     document.querySelector('[data-judgeme-widget]') ||
                     document.querySelector('#judgeme_product_reviews') ||
                     document.querySelector('[id*="reviews"]') ||
                     document.querySelector('[id*="judge"]');

        if (target) {
          var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '72', 10);
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
      });
    }
  }

  function fetchJudgeMeRating(productId, callback) {
    var attempts = 0;
    var maxAttempts = 15;

    function check() {
      attempts++;

      // Try to find Judge.me widget with data attributes
      var widget = document.querySelector('.jdgm-rev-widg[data-average-rating][data-number-of-reviews]');

      if (widget) {
        var rating = parseFloat(widget.dataset.averageRating) || 0;
        var count = parseInt(widget.dataset.numberOfReviews, 10) || 0;

        if (count > 0) {
          callback({ rating: rating, count: count });
          return;
        }
      }

      // Alternative: scrape from visible elements
      var summaryText = document.querySelector('.jdgm-rev-widg__summary-text');
      var ratingNum = document.querySelector('.jdgm-rev-widg__summary-rating-num');

      if (summaryText) {
        var match = summaryText.textContent.match(/(\d+)\s*review/i);
        var count = match ? parseInt(match[1], 10) : 0;
        var rating = ratingNum ? parseFloat(ratingNum.textContent) : 5;

        if (count > 0) {
          callback({ rating: rating, count: count });
          return;
        }
      }

      // Try Judge.me preview badge
      var badge = document.querySelector('.jdgm-prev-badge[data-average-rating]');
      if (badge) {
        var rating = parseFloat(badge.dataset.averageRating) || 0;
        var count = parseInt(badge.dataset.numberOfReviews, 10) || 0;

        if (count > 0) {
          callback({ rating: rating, count: count });
          return;
        }
      }

      // Count filled stars from Judge.me elements
      var starsContainer = document.querySelector('.jdgm-rev-widg__summary-stars, .jdgm-star-rating');
      if (starsContainer) {
        var filledStars = starsContainer.querySelectorAll('.jdgm-star.jdgm--on, .jdgm--full').length;
        if (filledStars > 0) {
          // Try to get count from nearby text
          var nearbyText = starsContainer.closest('.jdgm-rev-widg__summary, .jdgm-prev-badge');
          var count = 0;
          if (nearbyText) {
            var match = nearbyText.textContent.match(/(\d+)\s*review/i);
            count = match ? parseInt(match[1], 10) : 0;
          }
          if (count > 0) {
            callback({ rating: filledStars, count: count });
            return;
          }
        }
      }

      if (attempts < maxAttempts) {
        setTimeout(check, 400);
      } else {
        // Final attempt: check if any Judge.me element exists
        var anyJudgeMe = document.querySelector('[class*="jdgm"]');
        if (anyJudgeMe) {
          // Try parsing any visible number as review count
          var allText = anyJudgeMe.textContent || '';
          var numMatch = allText.match(/(\d+)\s*review/i);
          if (numMatch) {
            callback({ rating: 5, count: parseInt(numMatch[1], 10) });
            return;
          }
        }
        callback(null);
      }
    }

    // Start checking after Judge.me loads
    setTimeout(check, 500);
  }

  function renderStars(pill, rating, count) {
    var starsContainer = pill.querySelector('[data-stars-container]');
    var countEl = pill.querySelector('[data-rating-count]');

    if (countEl) countEl.textContent = count + ' Reviews';

    if (starsContainer) {
      var stars = starsContainer.querySelectorAll('.star-rating-pill__star');
      var fullStars = Math.round(rating);

      stars.forEach(function(star, index) {
        star.classList.remove('star--filled', 'star--empty');
        star.classList.add(index < fullStars ? 'star--filled' : 'star--empty');
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStarRatingPill);
  } else {
    initStarRatingPill();
  }

  document.addEventListener('shopify:section:load', initStarRatingPill);
})();
  } catch(e) { console.error(e); }
})();

})();
